import { render, staticRenderFns } from "./RybelsusStatusIcon.vue?vue&type=template&id=013240da&scoped=true&"
import script from "./RybelsusStatusIcon.vue?vue&type=script&lang=js&"
export * from "./RybelsusStatusIcon.vue?vue&type=script&lang=js&"
import style0 from "./RybelsusStatusIcon.vue?vue&type=style&index=0&id=013240da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013240da",
  null
  
)

export default component.exports